export default {
	messages: {
		ru: {
			'Авто пригнанные из США': 'Авто пригнанные из США',
			'Все': 'Все',
			'Показать': 'Показать',
			'Скрыть': 'Скрыть'
		},
		uk: {
			'Авто пригнанные из США': 'Авто пригнані із США',
			'Все': 'Всі',
			'Показать': 'Показати',
			'Скрыть': 'Сховати'
		},
	}
};
